/* 3dprintedmom Thanksgiving pie-spin popup (2026-11-01, seasonal swap for the chip-drop game). Loaded by
   snippets/pie-spin.liquid, which also passes the three photo assets (data-pie, data-server, data-bg; made with
   Higgsfield). A real pumpkin pie turns slowly on its plate until the visitor hits SPIN; it spins, stops with a
   "20% OFF FILES" slice under the pie server, and the server cuts that slice and lifts it out.
   Same odds and premise as the chip drop: every spin lands on one of the two "20% OFF FILES" slices; the other
   slices are display only (disclosed in Terms). The code is only revealed after the visitor subscribes via
   Shopify's newsletter (customer) form; the discount itself is limited to customers with no orders, one use each.
   Shows once per browser, ever: marked seen the moment it opens. It has its own storage key (not the wheel/chip-drop
   one), so everyone gets one pie spin even if they already played those; SPIN20 stays one use per customer anyway.
   ?pie=1 / ?plinko=1 / ?spin=1 forces it open, ?pie=reset (or the others) clears it. */
(function () {
  var script = document.currentScript;
  if (!script || window.__plinko) return;
  window.__plinko = true;

  var CODE = script.dataset.code || 'SPIN20';
  var SHOP = script.dataset.shop || '/collections/digital-downloads';
  var PIE_IMG = script.dataset.pie, SERVER_IMG = script.dataset.server, BG_IMG = script.dataset.bg;
  var CLAIM = '/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(SHOP);
  var KEY = '3dpm-pie-v1', SOUND_KEY = '3dpm-sound';
  var OPEN_DELAY = 1200;
  var DISPLAY = "'Fraunces',Georgia,serif", LABEL = "'Fredoka',system-ui,sans-serif";

  // Pie geometry (SVG units). Slice i is centred at -90 + i*45 degrees before the pie turns, so slice 0 starts
  // under the server at 12 o'clock. The pie photo is 633x640 with its centre at 315,322 and crimp peaks ~316px out;
  // the filling ends ~250px out. The server photo is 102x480 with its blade tip at 50.5,479.
  var VW = 340, VH = 460, CX = 170, CY = 300, CR = 140, R = 111, PLATE = 158;
  var PIE_K = CR / 316, PIE_W = 633, PIE_H = 640, PIE_CX = 315, PIE_CY = 322;
  var SRV_K = 0.45, SRV_W = 102, SRV_H = 480, SRV_TX = 50.5, SRV_TY = 479, SRV_TILT = 40;
  var SEG = 45, TIP_Y = CY - R + 6, REST = -22, CHOP = 26, LIFT = 58, WIN_SLICES = [2, 6];
  var SLICES = [
    { t: 'FREE', s: 'SHIPPING' },
    { t: '15%',  s: 'OFF' },
    { t: '20%',  s: 'OFF FILES' },
    { t: '$10',  s: 'OFF' },
    { t: 'FREE', s: 'GUIDE', star: true },
    { t: '$10',  s: 'OFF' },
    { t: '20%',  s: 'OFF FILES' },
    { t: '15%',  s: 'OFF' }
  ];

  function load() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  var params = new URLSearchParams(location.search);
  var flag = params.get('pie') || params.get('plinko') || params.get('spin');
  if (flag === 'reset') { try { localStorage.removeItem(KEY); } catch (e) {} }
  var forced = flag === '1';
  var state = forced ? null : load();
  var reopen = false;
  // Back from Shopify's bot challenge after a native newsletter submit: the signup went through.
  if (state && state.pending && params.get('customer_posted') === 'true') {
    state = { s: 'claimed', t: Date.now(), email: state.pending };
    save(state);
    reopen = true;
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var showPopup = !state && (forced || !script.dataset.guide);   // guide pages: wait for the next non-guide page
  var showPill = state && (state.s === 'won' || state.s === 'claimed') && !state.pillHidden;
  if (!showPopup && !showPill && !reopen) return;

  var fonts = document.createElement('link');
  fonts.rel = 'stylesheet';
  fonts.href = 'https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@1,9..144,900&family=Fredoka:wght@600;700&display=swap';
  document.head.appendChild(fonts);

  var SHADE = 'linear-gradient(rgba(30,12,2,.55),rgba(30,12,2,.05) 32%,rgba(30,12,2,0) 70%,rgba(30,12,2,.35))';
  var CSS = [
    '.pc-overlay{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:1rem;background:rgba(35,15,4,.72);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;transition:opacity .25s ease}',
    '.pc-overlay[hidden]{display:none}',
    '.pc-overlay.is-open{opacity:1}',
    // The card is the Thanksgiving table photo, darkened at the top so the headline reads.
    '.pc-card{position:relative;box-sizing:border-box;width:100%;max-width:26rem;max-height:calc(100dvh - 2rem);overflow-y:auto;overflow-x:hidden;border:5px solid #E9B44C;border-radius:1.75rem;box-shadow:0 0 0 4px #5A2A0C,0 28px 70px rgba(0,0,0,.55);padding:1.2rem 1.1rem 1rem;text-align:center;color:#FFF3DF;font-family:system-ui,-apple-system,sans-serif;' +
      'background:' + SHADE + ',#4A2410;background-size:cover;background-position:center;' +
      'transform:scale(.6) rotate(-6deg);transition:transform .55s cubic-bezier(.34,1.7,.5,1)}',
    '.pc-card *{box-sizing:border-box}',
    '.pc-card>:not(.pc-leaves){position:relative;z-index:1}',
    '.pc-overlay.is-open .pc-card{transform:none}',
    '.pc-leaves{position:absolute;inset:0;overflow:hidden;pointer-events:none;z-index:0}',
    '.pc-leaf{position:absolute;top:-2rem;width:15px;height:15px;border-radius:0 80% 0 80%;opacity:.8;animation:pc-fall linear infinite}',
    '@keyframes pc-fall{from{transform:translate(0,0) rotate(0)}50%{transform:translate(28px,22rem) rotate(200deg)}to{transform:translate(-12px,46rem) rotate(400deg)}}',
    '.pc-x,.pc-mute{position:absolute !important;top:.55rem;z-index:2 !important;display:flex;align-items:center;justify-content:center;width:2.3rem;height:2.3rem;border:3px solid #5A2A0C;border-radius:50%;background:#FFF3DF;color:#5A2A0C;line-height:1;cursor:pointer;box-shadow:0 3px 0 #5A2A0C}',
    '.pc-x{right:.55rem;font-size:1.45rem;font-weight:800}',
    '.pc-mute{left:.55rem;font-size:.95rem}',
    '.pc-eyebrow{display:inline-block;font-family:' + LABEL + ';font-weight:700;font-size:.74rem;letter-spacing:.08em;background:#4F6B2A;color:#FFF3DF;padding:.3rem .85rem;border-radius:999px;margin:.15rem 2.4rem 0;white-space:nowrap;box-shadow:0 3px 0 #2F4317}',
    '.pc-title{font-family:' + DISPLAY + ';font-style:italic;font-weight:900;font-size:2.7rem;line-height:1;color:#FFB347;margin:.5rem 0 .55rem;text-shadow:0 2px 0 #7A3410,0 4px 0 #4A1F06,0 8px 18px rgba(0,0,0,.6);transform:rotate(-2deg)}',
    '.pc-sub{display:inline-block;background:rgba(255,243,223,.95);color:#5A2A0C;font-weight:800;font-size:.86rem;line-height:1.35;padding:.4rem .95rem;border-radius:999px;margin:0;max-width:21rem;box-shadow:0 3px 0 #5A2A0C}',
    '.pc-card :focus-visible{outline:3px solid #FFB347;outline-offset:2px}',
    '.pc-board{display:block;width:min(20rem,82vw,calc(46dvh * .739));margin:.5rem auto .5rem;padding:0;border:0;background:none;cursor:pointer;transition:width .45s ease}',
    '.pc-board:disabled{cursor:default}',
    '.pc-board svg{display:block;width:100%;height:auto;overflow:visible}',
    '.pc-board text{font-family:' + LABEL + ';font-weight:700;text-anchor:middle;pointer-events:none;paint-order:stroke;stroke-linejoin:round}',
    '.pc-lift .pc-slice{filter:drop-shadow(0 12px 8px rgba(30,12,2,.5))}',
    '.pc-actions{display:flex;flex-direction:column;align-items:center;gap:.45rem}',
    '.pc-actions[hidden],.pc-result[hidden]{display:none}',
    '.pc-btn{display:inline-flex;align-items:center;justify-content:center;border:4px solid #F2C46B;border-radius:999px;background:linear-gradient(#F28A2E,#C9561A);color:#fff;font-family:' + LABEL + ';font-weight:700;font-size:1.05rem;letter-spacing:.04em;padding:.75rem 1.4rem;cursor:pointer;text-decoration:none;box-shadow:0 6px 0 #5A2A0C,0 12px 22px rgba(0,0,0,.35);text-shadow:0 2px 0 rgba(0,0,0,.2);transition:transform .08s,box-shadow .08s}',
    '.pc-btn:active{transform:translateY(4px);box-shadow:0 2px 0 #5A2A0C,0 6px 12px rgba(0,0,0,.3)}',
    '.pc-go{min-width:12rem;font-size:1.6rem;padding:.55rem 2.2rem;animation:pc-pulse 1.1s ease-in-out infinite}',
    '.pc-go:disabled{animation:none;opacity:.75;cursor:default}',
    '@keyframes pc-pulse{50%{transform:scale(1.07)}}',
    '.pc-alt{background:linear-gradient(#FFD36B,#F2B33D);color:#4A220A;border-color:#5A2A0C;box-shadow:0 5px 0 #4A220A;text-shadow:none}',
    '.pc-alt:active{box-shadow:0 1px 0 #4A220A}',
    '.pc-no{border:0;background:rgba(30,12,2,.45);border-radius:999px;color:#FFF3DF;font-family:inherit;font-weight:800;font-size:.85rem;padding:.35rem .85rem;cursor:pointer;text-decoration:underline;text-underline-offset:3px}',
    '.pc-result{animation:pc-in .45s cubic-bezier(.34,1.56,.64,1)}',
    '@keyframes pc-in{from{opacity:0;transform:translateY(14px) scale(.95)}}',
    '.pc-winner{font-family:' + DISPLAY + ';font-style:italic;font-weight:900;font-size:2.4rem;line-height:1;color:#FFB347;margin:0;text-shadow:0 2px 0 #7A3410,0 4px 0 #4A1F06,0 8px 18px rgba(0,0,0,.6);transform:rotate(-2deg);animation:pc-flash .4s steps(1) 7}',
    '@keyframes pc-flash{50%{color:#FFF3DF}}',
    '.pc-won{display:inline-block;font-family:' + LABEL + ';font-weight:700;font-size:1.05rem;line-height:1.25;color:#FFF3DF;background:rgba(30,12,2,.55);padding:.3rem .9rem;border-radius:999px;margin:.5rem 0 .7rem}',
    '.pc-won b{color:#FFB347}',
    '.pc-panel{background:#FFF8EC;color:#4A220A;border:4px solid #5A2A0C;border-radius:1.25rem;box-shadow:0 6px 0 #4A220A;padding:.9rem .9rem 1rem}',
    '.pc-won-sub{font-size:.9rem;font-weight:700;line-height:1.4;color:#6E4A2E;margin:0 auto .75rem;max-width:20rem;text-wrap:balance}',
    '.pc-code{display:flex;align-items:center;justify-content:center;gap:.7rem;margin:.1rem 0 .9rem}',
    '.pc-tag{position:relative;display:inline-block;background:#FFD36B;color:#4A220A;font-family:' + LABEL + ';font-weight:700;font-size:1.45rem;letter-spacing:.06em;padding:.45rem 1rem .45rem 1.9rem;clip-path:polygon(18px 0,100% 0,100% 100%,18px 100%,0 50%);border-radius:0 .5rem .5rem 0;transform:rotate(-3deg)}',
    '.pc-tag:before{content:"";position:absolute;left:12px;top:50%;width:9px;height:9px;margin-top:-4.5px;border-radius:50%;background:#fff;box-shadow:inset 0 0 0 2px #4A220A}',
    '.pc-copy{border:0;border-radius:999px;background:#5A2A0C;color:#fff;font-family:' + LABEL + ';font-weight:700;font-size:.8rem;padding:.55rem .9rem;cursor:pointer;box-shadow:0 3px 0 #3F1D07}',
    '.pc-claim{display:flex;width:100%;max-width:17rem;margin:0 auto}',
    '.pc-step-email[hidden],.pc-step-code[hidden],.pc-err[hidden]{display:none}',
    '.pc-form{display:flex;flex-direction:column;gap:.55rem;max-width:18rem;margin:0 auto}',
    '.pc-input{width:100%;border:3px solid #5A2A0C;border-radius:999px;background:#fff;padding:.7rem 1.1rem;font-family:inherit;font-size:1rem;font-weight:700;color:#4A220A;text-align:center;outline:0}',
    '.pc-input:focus{border-color:#E0731F;box-shadow:0 0 0 3px rgba(224,115,31,.25)}',
    '.pc-sub-btn{width:100%}',
    '.pc-err{color:#B3261E;font-size:.85rem;font-weight:700;margin:0}',
    '.pc-fine{font-size:.72rem;color:#7A5A40;margin:.6rem auto 0;max-width:18rem;line-height:1.4}',
    '.pc-sr{position:absolute !important;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
    '.pc-note{font-size:.78rem;color:#7A5A40;margin:.55rem 0 0}',
    '.pc-terms{margin-top:.8rem;font-size:.72rem;color:#FFF3DF;font-weight:700}',
    '.pc-terms summary{cursor:pointer;display:inline-block;text-decoration:underline;text-underline-offset:2px;text-shadow:0 1px 2px #000}',
    '.pc-terms p{margin:.45rem 0 0;text-align:left;line-height:1.45;font-weight:600;color:#4A220A;background:rgba(255,248,236,.96);padding:.6rem .75rem;border-radius:.75rem}',
    '.pc-confetti{position:fixed;top:0;left:0;width:12px;height:12px;border-radius:0 80% 0 80%;z-index:1001;pointer-events:none}',
    '.pc-pill{position:fixed;left:1rem;bottom:1rem;z-index:45;display:flex;align-items:center;border:3px solid #F2C46B;border-radius:999px;background:#5A2A0C;color:#FFD36B;box-shadow:0 0 0 3px #E0731F,0 10px 30px rgba(0,0,0,.3);font-family:' + LABEL + ';font-weight:700;letter-spacing:.03em;animation:pc-in .45s cubic-bezier(.34,1.56,.64,1)}',
    '.pc-pill button{border:0;background:none;color:inherit;font:inherit;cursor:pointer}',
    '.pc-pill-open{padding:.6rem .4rem .6rem 1rem;font-size:.82rem}',
    '.pc-pill-x{padding:.6rem .9rem .6rem .5rem;font-size:1.1rem;color:#fff !important}',
    '.pc-card.is-won .pc-board{width:min(13rem,56vw,calc(30dvh * .739));margin:.3rem auto .5rem}',
    '@media(max-width:480px){.pc-title,.pc-winner{font-size:2.2rem}.pc-pill{left:.75rem;bottom:.75rem}}',
    '@media(max-height:740px){.pc-title{font-size:2rem;margin:.35rem 0 .4rem}.pc-card.is-won .pc-board{width:min(10rem,44vw,calc(24dvh * .739));margin:.2rem auto .4rem}}',
    '@media(prefers-reduced-motion:reduce){.pc-go,.pc-winner,.pc-leaf{animation:none}.pc-leaves{display:none}}'
  ].join('');

  function rad(d) { return d * Math.PI / 180; }
  function px(a, r) { return +(CX + Math.cos(rad(a)) * r).toFixed(2); }
  function py(a, r) { return +(CY + Math.sin(rad(a)) * r).toFixed(2); }
  function wedge(a, r) {
    return 'M' + CX + ' ' + CY + 'L' + px(a - SEG / 2, r) + ' ' + py(a - SEG / 2, r) +
      'A' + r + ' ' + r + ' 0 0 1 ' + px(a + SEG / 2, r) + ' ' + py(a + SEG / 2, r) + 'Z';
  }
  function sliceAngle(i) { return -90 + i * SEG; }
  function label(a, r, size, sw, fill, txt, dy) {
    return '<text transform="translate(' + px(a, r) + ' ' + py(a, r) + ') rotate(' + (a + 90) + ')" y="' + dy + '" font-size="' + size +
      '" fill="' + fill + '" stroke="#4A1A04" stroke-width="' + sw + '">' + txt + '</text>';
  }

  // Each slice is the same pie photo clipped to its own 45-degree wedge, so a lifted slice carries its own
  // crust and filling and the pie underneath shows the gap.
  function sliceSvg(b, i) {
    var a = sliceAngle(i);
    return '<g class="pc-slice" data-k="' + i + '">' +
      '<g clip-path="url(#pcClip' + i + ')"><image href="' + PIE_IMG + '" x="' + (CX - PIE_CX * PIE_K).toFixed(2) + '" y="' + (CY - PIE_CY * PIE_K).toFixed(2) +
        '" width="' + (PIE_W * PIE_K).toFixed(2) + '" height="' + (PIE_H * PIE_K).toFixed(2) + '" preserveAspectRatio="none"/></g>' +
      '<path d="' + wedge(a, R) + '" fill="none" stroke="#7A2E08" stroke-opacity=".35" stroke-width="1"/>' +
      label(a, 84, b.t.length > 3 ? 17 : 20, 4, '#FFF6E6', b.t, 6) +
      label(a, 63, 8.5, 3, '#FFF6E6', b.s, 3) +
      (b.star ? label(a, 43, 12, 2.5, '#FFD36B', '★', 4) : '') +
    '</g>';
  }

  function boardSvg() {
    var clips = SLICES.map(function (b, i) {
      return '<clipPath id="pcClip' + i + '"><path d="' + wedge(sliceAngle(i), CR + 14) + '"/></clipPath>';
    }).join('');
    var out = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" aria-hidden="true"><defs>' + clips +
      '<radialGradient id="pcPlate" cx=".45" cy=".4" r=".7"><stop offset="0" stop-color="#FFFDF8"/><stop offset=".8" stop-color="#F1E6D2"/><stop offset="1" stop-color="#D9C7A8"/></radialGradient>' +
      '<radialGradient id="pcTin" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#E2B074"/><stop offset=".75" stop-color="#C98E4E"/><stop offset="1" stop-color="#9C6332"/></radialGradient>' +
      '</defs>';
    // Plate (with a soft shadow on the table) and the baked bottom crust that shows where the slice is lifted out.
    out += '<ellipse cx="' + (CX + 4) + '" cy="' + (CY + 12) + '" rx="' + PLATE + '" ry="' + (PLATE - 4) + '" fill="rgba(20,8,0,.45)" style="filter:blur(6px)"/>';
    out += '<circle cx="' + CX + '" cy="' + CY + '" r="' + PLATE + '" fill="url(#pcPlate)"/>';
    out += '<circle cx="' + CX + '" cy="' + CY + '" r="' + (PLATE - 9) + '" fill="none" stroke="#C9A86A" stroke-width="1.5"/>';
    out += '<circle cx="' + CX + '" cy="' + CY + '" r="' + (CR - 6) + '" fill="url(#pcTin)"/>';
    out += '<g class="pc-pie">' + SLICES.map(sliceSvg).join('') + '</g>';
    // Pie server, tip at 0,0 in its own frame, tilted so the handle sits up and to the right.
    out += '<g class="pc-cutter"><g class="pc-wobble"><g transform="rotate(' + SRV_TILT + ')">' +
      '<image href="' + SERVER_IMG + '" x="' + (-SRV_TX * SRV_K).toFixed(2) + '" y="' + (-SRV_TY * SRV_K).toFixed(2) +
        '" width="' + (SRV_W * SRV_K).toFixed(2) + '" height="' + (SRV_H * SRV_K).toFixed(2) + '" style="filter:drop-shadow(3px 5px 4px rgba(20,8,0,.45))"/>' +
    '</g></g></g>';
    out += '<g class="pc-lift"></g>';   // the cut slice moves here so it rides on top of the server
    return out + '</svg>';
  }

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var overlay, card, board, pieEl, cutterEl, wobbleEl, liftEl, goBtn, muteBtn, actions, result, lastFocus;
  var spinning = false, won = false, idleRaf = 0, angle = 0, winSlice = 2, wobble = 0;
  var AX = -Math.sin(rad(SRV_TILT)), AY = Math.cos(rad(SRV_TILT));   // direction the blade points

  function setPie(a) {
    angle = a;
    var t = 'rotate(' + a.toFixed(2) + ' ' + CX + ' ' + CY + ')';
    pieEl.setAttribute('transform', t);
    liftEl.setAttribute('transform', t);
  }
  // push: how far the blade has pushed along its own axis; up: how far it has lifted straight up.
  function setCutter(push, up, w) {
    cutterEl.setAttribute('transform', 'translate(' + (CX + AX * push).toFixed(2) + ' ' + (TIP_Y + AY * push - (up || 0)).toFixed(2) + ')');
    wobbleEl.setAttribute('transform', 'rotate(' + (w || 0).toFixed(2) + ')');
  }
  function setLift(sl, d) {
    var a = rad(sliceAngle(+sl.dataset.k));
    sl.setAttribute('transform', 'translate(' + (Math.cos(a) * d).toFixed(2) + ' ' + (Math.sin(a) * d).toFixed(2) + ')');
  }

  // ---- Sound: tiny WebAudio blips, only ever started from the SPIN click. ----
  var actx = null;
  function soundOn() { try { return localStorage.getItem(SOUND_KEY) !== 'off'; } catch (e) { return true; } }
  function tone(freq, at, dur, type, vol) {
    if (!actx || !soundOn()) return;
    var t = actx.currentTime + at, o = actx.createOscillator(), g = actx.createGain();
    o.type = type; o.frequency.value = freq;
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(actx.destination);
    o.start(t); o.stop(t + dur + 0.03);
  }
  function tick() { tone(1100 + Math.random() * 400, 0, 0.04, 'triangle', 0.07); }
  function chop() { tone(160, 0, 0.09, 'square', 0.1); tone(95, 0.02, 0.14, 'sine', 0.18); }
  function fanfare() {
    [523, 659, 784, 1047].forEach(function (f, i) { tone(f, i * 0.11, 0.2, 'square', 0.05); });
    tone(1047, 0.44, 0.55, 'square', 0.05);
    [0.95, 1.2, 1.45].forEach(function (at) { tone(1568, at, 0.35, 'sine', 0.14); tone(2093, at, 0.25, 'sine', 0.05); });
  }
  function toggleSound() {
    var on = !soundOn();
    try { localStorage.setItem(SOUND_KEY, on ? 'on' : 'off'); } catch (e) {}
    muteBtn.textContent = on ? '🔊' : '🔇';
    muteBtn.setAttribute('aria-label', on ? 'Mute sound' : 'Turn sound on');
  }

  function leaves() {
    var colors = ['#C9561A', '#E0731F', '#F2B33D', '#9A3412', '#B5651D'], out = '';
    for (var i = 0; i < 6; i++) {
      out += '<i class="pc-leaf" style="left:' + (8 + i * 16) + '%;background:' + colors[i % colors.length] +
        ';animation-duration:' + (10 + (i * 3) % 7) + 's;animation-delay:-' + (i * 2.1).toFixed(1) + 's"></i>';
    }
    return '<div class="pc-leaves" aria-hidden="true">' + out + '</div>';
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pc-overlay';
    overlay.hidden = true;
    var on = soundOn();
    overlay.innerHTML =
      '<div class="pc-card" role="dialog" aria-modal="true" aria-labelledby="pc-title">' + leaves() +
        '<button type="button" class="pc-mute" aria-label="' + (on ? 'Mute sound' : 'Turn sound on') + '">' + (on ? '🔊' : '🔇') + '</button>' +
        '<button type="button" class="pc-x" aria-label="Close">&times;</button>' +
        '<p class="pc-eyebrow">🍂 HAPPY THANKSGIVING 🍂</p>' +
        '<h2 id="pc-title" class="pc-title">Spin the Pie!</h2>' +
        '<p class="pc-sub">Every slice is a prize. Spin it and we&rsquo;ll cut you yours!</p>' +
        '<button type="button" class="pc-board" aria-label="Spin the pie">' + boardSvg() + '</button>' +
        '<div class="pc-actions">' +
          '<button type="button" class="pc-btn pc-go">SPIN!</button>' +
          '<button type="button" class="pc-no">No thanks, I’m stuffed</button>' +
        '</div>' +
        '<div class="pc-result" hidden aria-live="polite">' +
          '<p class="pc-winner">Here&rsquo;s your slice!</p>' +
          '<p class="pc-won">You won <b>20% OFF</b> print files!</p>' +
          '<div class="pc-panel">' +
            '<div class="pc-step-email">' +
              '<p class="pc-won-sub">Subscribe to our emails to unlock your code. It&rsquo;s good on your first order of 3D print files.</p>' +
              '<form class="pc-form" method="post" action="/contact#pie" accept-charset="UTF-8" novalidate>' +
                '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
                '<input type="hidden" name="contact[tags]" value="newsletter,spin-wheel,pie-spin">' +
                '<label class="pc-sr" for="pc-email">Email</label>' +
                '<input id="pc-email" class="pc-input" type="email" name="contact[email]" placeholder="you@example.com" autocomplete="email" required>' +
                '<button type="submit" class="pc-btn pc-alt pc-sub-btn">CLAIM MY SLICE</button>' +
                '<p class="pc-err" role="alert" hidden></p>' +
              '</form>' +
              '<p class="pc-fine">By subscribing you&rsquo;ll get 3dprintedmom emails with new prints and offers. Unsubscribe anytime.</p>' +
            '</div>' +
            '<div class="pc-step-code" hidden>' +
              '<p class="pc-won-sub">You&rsquo;re subscribed! Check out with <b class="pc-email-echo"></b> so your code works (the guides aren&rsquo;t included).</p>' +
              '<div class="pc-code"><span class="pc-tag">' + CODE + '</span><button type="button" class="pc-copy">COPY</button></div>' +
              '<a class="pc-btn pc-claim" href="' + CLAIM + '">SHOP PRINT FILES &rarr;</a>' +
              '<p class="pc-note">We&rsquo;ll pop the code into your basket for you.</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<details class="pc-terms"><summary>Terms</summary><p>One spin per visitor. Every spin wins 20% off 3D print files (digital downloads) on your first order. ' +
          'To get the code, subscribe to 3dprintedmom emails. Code ' + CODE + ' only works at checkout with an email that has never ordered before. One use per email. ' +
          'Excludes the Before You Press Print and Press Print &amp; Walk Away guides. No cash value. ' +
          'The other prizes shown on the pie are for display and are not awarded.</p></details>' +
      '</div>';
    document.body.appendChild(overlay);
    card = overlay.querySelector('.pc-card');
    if (BG_IMG) card.style.backgroundImage = SHADE + ',url("' + BG_IMG + '")';
    board = overlay.querySelector('.pc-board');
    pieEl = overlay.querySelector('.pc-pie');
    cutterEl = overlay.querySelector('.pc-cutter');
    wobbleEl = overlay.querySelector('.pc-wobble');
    liftEl = overlay.querySelector('.pc-lift');
    goBtn = overlay.querySelector('.pc-go');
    muteBtn = overlay.querySelector('.pc-mute');
    actions = overlay.querySelector('.pc-actions');
    result = overlay.querySelector('.pc-result');
    setPie(-22);   // start between slices so nothing looks pre-picked
    setCutter(REST);

    overlay.querySelector('.pc-x').addEventListener('click', close);
    overlay.querySelector('.pc-no').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    muteBtn.addEventListener('click', toggleSound);
    board.addEventListener('click', spin);
    goBtn.addEventListener('click', spin);
    overlay.querySelector('.pc-copy').addEventListener('click', copyCode);
    overlay.querySelector('.pc-form').addEventListener('submit', subscribe);
    overlay.addEventListener('keydown', onKey);
  }

  function open(asWinner) {
    if (!overlay) build();
    if (asWinner) showResult(true);
    if (!won && !load()) save({ s: 'seen', t: Date.now() });   // leaving mid-popup still counts as the one showing
    lastFocus = document.activeElement;
    document.documentElement.style.overflow = 'hidden';
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    if (asWinner) focusStep(); else goBtn.focus({ preventScroll: true });
    if (!asWinner && !won) idle();
  }

  function close() {
    cancelAnimationFrame(idleRaf);
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 250);
    if (won || spinning) pill(); else save({ s: 'closed', t: Date.now() });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(card.querySelectorAll('button,a[href],summary,input'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  // Until it's spun, the pie turns slowly on the plate and the server hovers over it.
  function idle() {
    if (reduce) return;
    var last = performance.now(), t0 = last;
    (function frame(now) {
      setPie(angle + (now - last) * 0.012);
      setCutter(REST + Math.sin((now - t0) / 380) * 2.5);
      last = now;
      idleRaf = requestAnimationFrame(frame);
    })(t0);
  }

  function spin() {
    if (spinning || won) return;
    spinning = true;
    cancelAnimationFrame(idleRaf);
    board.disabled = goBtn.disabled = true;
    if (!actx) { try { actx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) {} }
    if (actx && actx.state === 'suspended') actx.resume();

    winSlice = WIN_SLICES[Math.floor(Math.random() * 2)];
    save({ s: 'won', t: Date.now() });   // outcome is fixed, so a close mid-spin still earns the pill

    // Slice k sits under the server when the pie is turned by -k*45 degrees (mod 360); a few degrees of
    // jitter keeps the stop from looking machined.
    var from = angle, target = ((-winSlice * SEG + (Math.random() * 8 - 4)) % 360 + 360) % 360;
    var delta = 4 * 360 + ((target - from % 360) % 360 + 360) % 360;
    var dur = reduce ? 1200 : 4600, start = performance.now();
    var lastIdx = Math.floor((from + SEG / 2) / SEG);

    (function frame(now) {
      var t = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - t, 4);
      setPie(from + delta * e);
      var idx = Math.floor((angle + SEG / 2) / SEG);
      if (idx !== lastIdx) { lastIdx = idx; tick(); wobble = 7; }   // the server flicks as each slice passes
      wobble *= 0.82;
      setCutter(REST, 0, wobble);
      if (t < 1) requestAnimationFrame(frame); else setTimeout(cut, reduce ? 0 : 350);
    })(start);
  }

  function tween(dur, step, done) {
    var start = performance.now();
    (function frame(now) {
      var t = dur ? Math.min(1, (now - start) / dur) : 1;
      step(t);
      if (t < 1) requestAnimationFrame(frame); else done();
    })(start);
  }

  // The server chops down into the winning slice, then lifts it up out of the pie.
  function cut() {
    var sl = pieEl.querySelector('[data-k="' + winSlice + '"]'), speed = reduce ? 0 : 1;
    tween(240 * speed, function (t) { setCutter(REST + (CHOP - REST) * t * t); }, function () {
      chop();
      liftEl.appendChild(sl);
      setTimeout(function () {
        tween(700 * speed, function (t) {
          var e = 1 - Math.pow(1 - t, 3);
          setLift(sl, LIFT * e);
          setCutter(CHOP, LIFT * e);
        }, land);
      }, 260 * speed);
    });
  }

  function land() {
    spinning = false;
    won = true;
    fanfare();
    if (!reduce && !overlay.hidden) confetti();
    setTimeout(function () { showResult(false); }, reduce ? 0 : 700);
  }

  function showResult(instant) {
    won = true;
    if (instant) {
      cancelAnimationFrame(idleRaf);
      setPie(-winSlice * SEG);
      var sl = pieEl.querySelector('[data-k="' + winSlice + '"]');
      if (sl) { liftEl.appendChild(sl); setLift(sl, LIFT); }
      setCutter(CHOP, LIFT);
      board.disabled = goBtn.disabled = true;
    }
    actions.hidden = true;
    card.classList.add('is-won');
    result.hidden = false;
    renderStep();
    if (!instant && !overlay.hidden) focusStep();
  }

  function claimedState() { var s = load(); return s && s.s === 'claimed' ? s : null; }

  function renderStep() {
    var c = claimedState();
    result.querySelector('.pc-step-email').hidden = !!c;
    result.querySelector('.pc-step-code').hidden = !c;
    if (c) result.querySelector('.pc-email-echo').textContent = c.email || 'the email you subscribed with';
  }

  // Touch screens skip auto-focusing the email box so the keyboard doesn't cover the win.
  function focusStep() {
    if (claimedState()) result.querySelector('.pc-claim').focus({ preventScroll: true });
    else if (matchMedia('(pointer: fine)').matches) result.querySelector('.pc-input').focus({ preventScroll: true });
  }

  // Newsletter signup through Shopify's built-in customer form. It must be a real form
  // submission: Shopify's captcha bootstrap intercepts submit events on /contact customer
  // forms, adds its token, then posts and returns here with ?customer_posted=true.
  function subscribe(e) {
    var form = e.currentTarget, input = form.querySelector('.pc-input');
    var btn = form.querySelector('.pc-sub-btn'), err = form.querySelector('.pc-err');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      e.preventDefault();
      err.textContent = 'Please enter a valid email address.'; err.hidden = false;
      input.focus();
      return;
    }
    input.value = email;
    err.hidden = true;
    var s = load() || { s: 'won', t: Date.now() };
    s.pending = email; save(s);
    btn.textContent = 'CLAIMING…';
  }

  // A burst of autumn leaves from the lifted slice.
  function confetti() {
    var sl = liftEl.querySelector('.pc-slice').getBoundingClientRect();
    var cx = sl.left + sl.width / 2, cy = sl.top + sl.height / 3;
    var colors = ['#C9561A', '#E0731F', '#F2B33D', '#9A3412', '#B5651D', '#FFE9C7'];
    for (var i = 0; i < 80; i++) {
      var p = document.createElement('i');
      p.className = 'pc-confetti';
      p.style.background = colors[i % colors.length];
      document.body.appendChild(p);
      var ang = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.4, dist = 160 + Math.random() * 260;
      var x = Math.cos(ang) * dist, y = Math.sin(ang) * dist;
      var turn = (Math.random() * 720 - 360) + 'deg';
      p.animate([
        { transform: 'translate(' + cx + 'px,' + cy + 'px) rotate(0) scale(.6)', opacity: 1 },
        { transform: 'translate(' + (cx + x) + 'px,' + (cy + y) + 'px) rotate(' + turn + ') scale(1)', opacity: 1, offset: .55 },
        { transform: 'translate(' + (cx + x * 1.15) + 'px,' + (cy + y + 320) + 'px) rotate(' + turn + ') scale(1)', opacity: 0 }
      ], { duration: 1900 + Math.random() * 1100, easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'forwards' })
        .onfinish = p.remove.bind(p);
    }
  }

  function copyCode() {
    var btn = overlay.querySelector('.pc-copy');
    function done() { btn.textContent = 'COPIED!'; setTimeout(function () { btn.textContent = 'COPY'; }, 1800); }
    function fallback() {
      var inp = document.createElement('input');
      inp.value = CODE; document.body.appendChild(inp); inp.select();
      try { document.execCommand('copy'); } catch (e) {}
      inp.remove(); done();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, fallback);
    else fallback();
  }

  // After a win, a small corner reminder follows the visitor around the site.
  function pill() {
    if (document.querySelector('.pc-pill')) return;
    var s = load() || { s: 'won', t: Date.now() };
    if (s.pillHidden) return;
    var el = document.createElement('div');
    el.className = 'pc-pill';
    el.innerHTML = '<button type="button" class="pc-pill-open">' +
      (s.s === 'claimed' ? '🥧 20% OFF FILES: ' + CODE : '🥧 CLAIM YOUR 20% OFF') + '</button>' +
      '<button type="button" class="pc-pill-x" aria-label="Hide discount reminder">&times;</button>';
    document.body.appendChild(el);
    el.querySelector('.pc-pill-open').addEventListener('click', function () { el.remove(); open(true); });
    el.querySelector('.pc-pill-x').addEventListener('click', function () {
      s.pillHidden = true; save(s); el.remove();
    });
  }

  function start() {
    if (reopen) open(true);
    else if (showPill) pill();
    else setTimeout(function () { open(false); }, forced ? 300 : OPEN_DELAY);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
